import styled, { css } from 'styled-components';
import { typography } from 'styled-system';

import { Box } from '@/components/Box';

import type { TextProps } from './Text';

export const Text = styled(Box)<TextProps>`
  text-transform: ${({ textTransform }) => textTransform};
  text-decoration: ${({ textDecoration }) => textDecoration};
  ${typography};

  ${({ before }) =>
    before &&
    css`
      &::before {
        content: '${before}';
      }
    `};

  ${({ after }) =>
    after &&
    css`
      &::after {
        content: '${after}';
      }
    `};
`;
